var unirest = require('unirest');
const API = require ('Api') ;

export async function getMyDebt ( token ) {
    const res =  await unirest.get(API.V2 + API.FINANCE + 'debt'  )
            .headers({'Authorization': 'Bearer ' + token });
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


export async function getMyCourseBirthdays ( token , calendarID) {
    const res =  await unirest.get( API.V2   + API.TUTORS + "my-courses/birthdays" )
    .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
    console.log(list)
return list ;
}
